import { EventEmitter, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BuyerSurveyResponse } from '../shared/interfaces/survey.interface';
import { CreateSurveyService } from './create-survey.service';

@Injectable({
  providedIn: 'root',
})
export class MarketplaceService {
  constructor(private _creatSurveyService: CreateSurveyService) {}

  private _newSurvey = new EventEmitter<BuyerSurveyResponse>();
  private _updateSurvey = new EventEmitter<{
    survey: BuyerSurveyResponse;
    action: string | null;
  }>();

  invokeUpdateSurvey = new EventEmitter();
  invokeLaunchSurvey = new EventEmitter();

  setNewSurveyDetails(survey: BuyerSurveyResponse) {
    this._newSurvey.emit(survey);
  }

  onCreateSurveyComplete(): Observable<BuyerSurveyResponse> {
    return this._newSurvey.asObservable();
  }

  setUpdateSurveyDetails(survey: BuyerSurveyResponse, action: string | null) {
    this._updateSurvey.emit({ survey, action });
  }

  onUpdateSurveyComplete(): Observable<{
    survey: BuyerSurveyResponse;
    action: string | null;
  }> {
    return this._updateSurvey.asObservable();
  }

  updateSurvey() {
    this.invokeUpdateSurvey.emit();
  }

  launchSurvey() {
    this.invokeLaunchSurvey.emit();
  }

  resetMultiCountryData() {
    this._creatSurveyService.resetMultiCountryData();
  }
}
